export default __webpack_public_path__ + "static/media/mag_feature1.ef0be985.jpg";